import PropTypes from 'prop-types';
import React from 'react';
import Grid from '@material-ui/core/Grid';
import { Chip } from '@material-ui/core';
import { Link } from 'react-router-dom';

import Img from 'retired/Img';
import ArrowRightIcon from 'assets/icons/arrow-right.svg';
import NonprofitLink from 'retired/NonprofitLink';
import { currenciesFormat } from 'utils/currencyFormat';
import { blackish } from 'utils/color-styles';
import { DeedListDateInfoWithStatus } from 'components/DeedListDateInfoWithStatus';
import { deedStyles } from 'containers/VolunteerPage/deedStyles';

const Donation = ({ donation, user }) => (
  <Link style={{ color: blackish }} to={`/donations/${donation.id}`}>
    <div style={deedStyles}>
      <DeedListDateInfoWithStatus date={donation.date}></DeedListDateInfoWithStatus>
      <div style={{ flexGrow: 1, marginLeft: 28 }}>
        <Grid container alignItems="center">
          <Grid item xs={8} style={{ height: '100%', margin: '0 !important' }}>
            <h3
              style={{
                fontSize: 15,
                fontWeight: 500,
                margin: '0px 0px 7px',
              }}
            >
              {donation.nonprofits.map((nonprofit, i) => (
                <React.Fragment key={nonprofit.id}>
                  <NonprofitLink nonprofit={nonprofit} />
                  {i + 1 < donation.nonprofits.size ? ', ' : ''}
                </React.Fragment>
              ))}
              {donation.paymentMethodDetails?.additionalData?.nonprofit?.externalName}
              {donation.isExternal() ? (
                <Chip
                  size="small"
                  label={donation.deedName}
                  style={{
                    marginLeft:
                      donation.nonprofits.size > 0 ||
                      donation.paymentMethodDetails?.additionalData?.nonprofit?.externalName
                        ? 10
                        : 0,
                    borderRadius: 4,
                    fontSize: 10,
                  }}
                />
              ) : donation.deed ? (
                ` • ${donation.deedName}`
              ) : (
                ''
              )}
            </h3>
            <div style={{ fontSize: 12 }}>
              Amount donated: {currenciesFormat(donation.amountCurrencies, user.displayCurrency)}
              {donation.matchedAmount ? (
                <span style={{ marginLeft: 36 }}>
                  Match: {currenciesFormat(donation.matchedAmountCurrencies, user.displayCurrency)}
                </span>
              ) : (
                ''
              )}
            </div>
          </Grid>
          <Grid item xs={4}>
            <div
              style={{
                display: 'flex',
                flexWrap: 'wrap',
                height: 93,
                paddingTop: 5,
                overflow: 'hidden',
                alignItems: 'flex-end',
              }}
            />
          </Grid>
        </Grid>
      </div>
      <div style={{ lineHeight: '100px' }}>
        <Img
          src={ArrowRightIcon}
          alt=""
          style={{
            height: 24,
            verticalAlign: 'middle',
            marginLeft: 38,
            marginRight: 38,
          }}
        />
      </div>
    </div>
  </Link>
);
Donation.propTypes = {
  donation: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
};

export default Donation;
